<div *ngIf="isLoading" class="overlay">
  <div class="center">
    <!--<mat-progress-spinner mode="indeterminate" color="primary"></mat-progress-spinner>-->
    <div class="loading-wapple">&nbsp;</div>
  </div>
</div>

